<template>
  <div class="pending_container">
    <div class="pending_inside">
      <h1>{{ getTranslations.home_pending_req_you_challenged }}</h1>
      <div class="pending_user">
        <img :src=challengeInfo.challengedAvatar alt="">
        <span class="name">{{ challengeInfo.challengedUsername }}</span>
        <span class="level">{{ getTranslations.home_pending_req_level }} {{ challengeInfo.challengedLevel }}</span>
      </div>
      <div class="waiting_content">
        <p>{{ getTranslations.home_pending_req_wait_opponent }}
        </p>
        <div id="timer"></div>
      </div>
    </div>
    <!-- dynamically change modals -->
    <component :is="modalForChallenge" @close="closeModalValidationsPending"></component>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RequestForRematch from '@/common/mixins/extraRematchInfo';
import { RematchMixin, BeforeDestroyRematch } from '@/common/mixins/rematch/rematch';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin } from '@/common/mixins/game';
import PendingTimeRematch from '@/common/jQueryMixin';
import ZeroBalance from '../../modals/ZeroBalance';

export default {
  components: { ZeroBalance },
  mixins: [ParseResponseMixin, NewGameMixin, RematchMixin, RequestForRematch, BeforeDestroyRematch, PendingTimeRematch],
  name: 'pending-request',
  data() {
    return {
      currentModal: null,
    };
  },
  created() {
    this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: false });
    this.updateValidRedirectionToPendingRequestPage(false);
    document.body.classList.add('pending_request');
    this.rematchWithSpecificUser();
  },
  beforeDestroy() {
    // eslint-disable-next-line
    console.log('in PendingRequest beforeDestroy hook');
    this.onTimesUp();
    document.body.classList.remove('pending_request');
    this.setToDefaultChallengeInfo();
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initiateTimer(this.timeToAcceptChallenge / 1000, 0, false);
      // fix animation on window resize
      // eslint-disable-next-line
      // $(window).resize(() => this.initiateTimer(this.timeToAcceptChallenge / 1000, 0, false));
    });
  },
  methods: {
    ...mapActions('profile', [
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
    ]),
    ...mapMutations('game', [
      'updateValidRedirectionToPendingRequestPage',
      'setToDefaultChallengeInfo',
    ]),
    ...mapMutations('users', [
      'setDeclinedReason',
    ]),
    ...mapMutations('common', [
      'storeModalForChallenge',
    ]),
    closeModalValidationsPending() {
      this.$router.push('/home');
      this.setDeclinedReason('');
      this.storeModalForChallenge(null);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'modalForChallenge',
      'timeToAcceptChallenge',
    ]),
    ...mapState('game', [
      'challengeInfo',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/PendingRequest.vue